import { LauncherAppTile } from "../models/LauncherApp";

// Tile backdrop for the App Launcher module and its apps (white glyph on top).
export const APP_LAUNCHER_COLOR = "#0dcbfb";

// Adds login_hint=<username> to an app's URL when it takes the Command Center
// session. No token travels in the URL: an app in the same Azure AD B2C tenant
// starts its own sign-in with this hint, and B2C's tenant-wide SSO session
// signs the user in without a prompt.
// The username must be the B2C sign-in email; anything else (e.g. the
// "Unknown" placeholder) is not a usable hint and is left off.
export const buildLaunchUrl = (app: Pick<LauncherAppTile, "url" | "passSession">, username?: string) => {
  if (!app.passSession || !username?.includes("@")) {
    return app.url;
  }

  try {
    const url = new URL(app.url);
    url.searchParams.set("login_hint", username);
    return url.toString();
  } catch {
    return app.url;
  }
};

// The same rule the API enforces: a full https:// address.
export const isHttpsUrl = (value: string) => {
  try {
    const url = new URL(value);
    return url.protocol === "https:" && !!url.hostname;
  } catch {
    return false;
  }
};
